import { useNavigate } from "react-router-dom";
import { cookieGetter } from '../utils/HelperFunction'
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useDataContext } from "../Context/context";
import { toast } from "react-toastify";
import { NEW_BACKENDBASEURL } from "../utils/constants";

const UserController = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const { setEditData } = useDataContext();
  const appIdToken = cookieGetter("appIdToken");
  const [userData, setUserData] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const notify = () => toast(`You don't have permission to access this page.`);
  const getUserUsingAPI = useCallback(
    async (selected) => {
      try {
        const baseUrl = `${NEW_BACKENDBASEURL}`;
        const response = await axios.get(
          `${NEW_BACKENDBASEURL}/users`,
          {
            baseUrl,
            method: "GET",
            headers: { Authorization: `Bearer ${appIdToken}` },
          }
        );
        setLoading(false);
        setUserData(response?.data);
        return response?.data;
      } catch (error) {
        setLoading(false);
        console.error("Error fetching entities:", error);
        // throw error;
      }
    },
    [appIdToken]
  );

  const fetchUserProfile = async () => {
    try {
      const response = await axios.get(
        `${NEW_BACKENDBASEURL}/users/profile`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${appIdToken}` },
        }
      );

      setProfile(response?.data?.users)
    } catch (err) {
      console.error("error in fetching profile", err)
    }
  }

  const baseURL = `${NEW_BACKENDBASEURL}/users`;
  const saveUserData = async (finalObject) => {
    fetch(
      finalObject.id
        ? `${NEW_BACKENDBASEURL}/users/${finalObject.id}`
        : baseURL,
      {
        method: finalObject.id ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${appIdToken}`,
        },
        body: JSON.stringify(finalObject),
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Handle the response data here
        const notify = () => toast(`User Created Successfully `);
        notify();
        navigate("/user");
      })
      .catch((error) => {
        // Handle any errors that occurred during the fetch.
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    getUserUsingAPI();
    fetchUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);

    const filtered = userData.users.filter((item) =>
      item.name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleCopy = (editData) => {
    const data = userData?.users.filter(
      (userData) => userData?.id === editData
    );
    setEditData(data);
    setLoading(false);
    navigate("/new-user");
  };

  const handleDelete = async (deleteData) => {
    try {
      const response = await axios.patch(
        `${NEW_BACKENDBASEURL}/users/${deleteData.id}:deactivate`,
        null,
        {
          headers: { Authorization: `Bearer ${appIdToken}` },
        }
      );

      if (response.status === 204) {
        const notify = () => toast(`The User is Deactivated`);
        notify();
      }

      window.location.reload();
    } catch (error) {
      console.error("Error deactivating user:", error);
    }
  };

  const handleRemove = async (deleteDataId) => {
    try {
      const response = await axios.delete(
        `${NEW_BACKENDBASEURL}/users/${deleteDataId}`,
        {
          headers: { Authorization: `Bearer ${appIdToken}` },
        }
      );

      if (response.status === 204) {
        const notify = () => toast(`The User Has Been Removed`);
        notify();
      }

      window.location.reload();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleActivate = async (activateData) => {
    try {
      const response = await axios.patch(
        `${NEW_BACKENDBASEURL}/users/${activateData.id}:activate`,
        null,
        {
          headers: { Authorization: `Bearer ${appIdToken}` },
        }
      );

      if (response.status === 204) {
        const notify = () => toast(`The User is Activated`);
        notify();
      }

      window.location.reload();
    } catch (error) {
      console.error("Error activating user:", error);
    }
  };

  return {
    getUserUsingAPI,
    saveUserData,
    userData,
    filteredData,
    handleSearch,
    searchInput,
    setSearchInput,
    handleDelete,
    handleRemove,
    handleActivate,
    handleCopy,
    loading,
    profile
  };
};

export default UserController;
